/**
 * FullscreenIcon - Icon representing fullscreen/expand action
 * Feature: 081-photo-versioning
 *
 * Standard fullscreen icon with four corner arrows pointing outward
 */

import type { IconProps } from './IconTypes';

export function FullscreenIcon({
  size = 20,
  className = '',
  'aria-label': ariaLabel = 'Fullscreen',
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-label={ariaLabel}
      role="img"
    >
      {/* Four corner arrows pointing outward */}
      <path d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4" />
    </svg>
  );
}
